import { createContext, type PropsWithChildren, useContext } from 'react'
import { useAsync } from 'react-use'
import { useJsBridgeCallbackInDom } from 'src/utils/jsBridge/domHook'
import {
  getAppMetadata,
  getProductListFromBridge,
  type MobileAppProductInfo,
} from 'src/utils/jsBridge/implementation'
import { GrowthEventName } from '~/features/GrowthEvent/store'
import { polling } from '~/utils/polling'

const JsBridgeContext = createContext(
  {} as {
    platform?: 'Android' | 'iOS'
    appVersion?: string
    appProducts?: MobileAppProductInfo[]
    loadingMobileVersion: boolean
  },
)
export default JsBridgeContext

const MAX_ATTEMPTS = 10

export function JsBridgeProvider({ children }: PropsWithChildren) {
  useJsBridgeCallbackInDom()

  const { value: metadata, loading } = useAsync(() => getAppMetadata(), [])
  // TODO: Remove hardcodes
  const { value: appProducts } = useAsync(
    () =>
      polling(
        () =>
          getProductListFromBridge({
            type: ['member', 'credit', 'surprisepack'],
            eventName: GrowthEventName.AprilFools2026,
          }),
        {
          maxAttempts: MAX_ATTEMPTS,
        },
      ),
    [],
  )

  return (
    <JsBridgeContext.Provider
      value={{
        platform: metadata?.platform,
        appVersion: metadata?.version,
        appProducts,
        loadingMobileVersion: loading,
      }}
    >
      {children}
    </JsBridgeContext.Provider>
  )
}

export const useJsBridgeContext = () => {
  return useContext(JsBridgeContext)
}
